import { useState, useCallback, useRef } from 'react'
import clsx from 'clsx'
import IconToken from '@/components/icons/IconToken'

export default function OrderFormInput({
  className = '',
  label,
  placeholder = '',
  unitLabel,
  unitLabelWidth,
  value,
  error,
  isEstimate = false,
  onUpdate
}) {
  unitLabelWidth = unitLabelWidth === 0 ? 'auto' : `${unitLabelWidth}px`

  const inputRef = useRef()
  const [focus, setFocus] = useState(false)
  const onChange = useCallback(
    e => onUpdate(label, e.target.value),
    [onUpdate, label]
  )
  const focusInput = () => inputRef.current && inputRef.current.focus()
  return (
    <div
      className={clsx('order-form-input-container', className, {
        focus,
        error: Boolean(error)
      })}
      onClick={focusInput}
    >
      {label && (
        <div
          className={clsx('order-form-input-label', {
            'is-estimate': isEstimate
          })}
        >
          {label} {isEstimate && '≈'}
        </div>
      )}
      <input
        ref={inputRef}
        type="text"
        className="order-form-input"
        placeholder={placeholder}
        value={value}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        onChange={onChange}
      />
      {unitLabel && (
        <div className="order-form-currency-block">
          <IconToken symbol={unitLabel} className="currency-icon" />
          <div
            className="order-form-input-label"
            style={{ width: unitLabelWidth }}
          >
            {unitLabel}
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
    </div>
  )
}
